<template>
  <div class="d-flex align-center">
    <v-btn v-if="isPadBool && searchfieldOpen" class="ml-n4" icon @click="forceblur()">
      <v-icon color="red">mdi-chevron-right</v-icon>
    </v-btn>
    <v-combobox :search-input="SearchQuery" :disabled="false"
      :items="(SearchQuery && resultset && Object.keys(resultset).length) ? [resultset] : []"
      prepend-inner-icon="mdi-magnify" no-filter
      :label="$t('servicesystem.common_objects.commonterms.global_search_hint')" single-line hide-details
      :clearable="(isPcBool || searchfieldOpen) && !!SearchQuery" dense
      :hide-no-data="!PastSearches || !PastSearches[0]" class="rounded-pill collapsingSearchfield"
      :class="[isPadBool ? 'mobile' : '', searchfieldOpen ? '' : 'closed']" :menu-props="{
        nudgeBottom: isPhoneBool ? 13 : 0,
        maxHeight: isPhoneBool ? 'calc(100vh - 88px)' : '93vh',
        minWidth: isPhoneBool ? '100vw' : (isPadBool ? '83vw' : '45vw'),
        maxWidth: isPhoneBool ? '100vw' : (isPadBool ? '83vw' : '45vw'),
      }" :loading="Object.values(resultset).some(x => x.loading)" :autofocus="searchfieldOpen" ref="Searchfield"
      @update:search-input="OnInputChange" @keyup.enter="OnPressEnter" @focus="forcefocus()"
      @blur="searchfieldOpen = false">
      <!-- @blur="forceblur()" -->

      <!-- dropdown chevron slot -->
      <template v-slot:append>
        <div></div>
      </template>

      <!-- progress bar slot -->
      <template v-slot:progress>
        <v-progress-linear indeterminate :color="'tertiary'" absolute
          style="position: absolute; z-index: 3000; margin-top: -3px;" height="3">
        </v-progress-linear>
      </template>

      <!-- dropdown before any search is initiated after last page load -->
      <template v-slot:no-data>
        <v-card class="pa-3 pt-2" style="cursor: context-menu !important;">
          <SearchHistory @RedoSearch="clickedTerm" />
        </v-card>
      </template>

      <!-- dropdown content -->
      <template v-slot:item="data">
        <v-container v-if="(PastSearches && PastSearches[0]) || SearchQuery" v-on:click.stop="" class="pa-0" style="margin-left: -16px !important;
                         margin-right: -16px !important;
                         min-width: calc(100% + 32px);">
          <v-card class="pa-3 pt-2" style="cursor: context-menu !important;">
            <SearchHistory @RedoSearch="e => { OnInputChange(e); storesearch(e) }" />

            <template v-if="SearchQuery">
              <v-row class="mt-0" no-gutters>
                <v-col>
                  <h2 v-html="$t('servicesystem.common_objects.commonterms.results_for_query', { xkey: SearchQuery })"
                    class=" useThemeTextColor nowrapheader" /> <!-- totalresultcount +  -->
                </v-col>
                <v-col cols="auto">

                  <!-- 
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs">
                        <v-btn disabled color="disabled" text :to="{ name: 'SearchResults' }">{{
      $t('servicesystem.common_objects.commonterms.full_search') }}
                          <v-icon size="18">mdi-chevron-right</v-icon>
                        </v-btn>
                      </div>
                    </template>
<span v-text="$t('servicesystem.common_objects.fallbackterms.Upcoming_Feature')" />
</v-tooltip>
-->
                </v-col>
              </v-row>

              <!-- filters -->
              <v-row v-if="SearchQuery" class="mt-0">
                <v-col class="py-0">
                  {{ $t('servicesystem.common_objects.commonterms.filters') }}
                  <div>
                    <v-chip v-for="wrapper in data.item" :key="wrapper.icon"
                      :outlined="wrapper.hide && !!wrapper.list[0]" :color="(!wrapper.list[0] ? 'disabled' : 'primary')"
                      class="mr-1" @click="toggleHide(wrapper)">
                      {{ wrapper.display }}
                    </v-chip> <!-- ({{ wrapper.list && wrapper.list.length }}) -->
                  </div>
                </v-col>
              </v-row>

              <!-- results -->
              <v-row v-if="SearchQuery" class="pt-3">
                <template v-for="wrapper in data.item">
                  <template v-if="!wrapper.hide">
                    <SearchResultWrapperList :query="SearchQuery" :wrapper="wrapper" :key="wrapper.tag"
                      :activeWrapperCount="activeWrapperCount">
                    </SearchResultWrapperList>
                  </template>
                </template>
              </v-row>
            </template>
          </v-card>
        </v-container>
      </template>
    </v-combobox>
  </div>
</template>


<script>
import Vue from "vue";
import clientAPI from "@/api/ClientAPIMixin.js";

import SearchHistory from "@/components/Sections/AppSections/SearchHistory.vue";
import SearchResultWrapperList from "@/components/Sections/AppSections/SearchResultWrapperList.vue";

export default {
  name: "GlobalSearch",
  props: {
    blurtrigger: Number,
    focustrigger: Number,
  },
  components: {
    SearchHistory,
    SearchResultWrapperList,
  },
  mixins: [clientAPI],

  data() {
    return {
      resultset: {},
      hideSearches: false,
      searchfieldOpen: false,

      timeout: 600,
      searchTimeout: null,
      cancelTokenContollerList: [],
    };
  },

  mounted() {
    let autocompleteInput = this.$refs.Searchfield.$refs.input;
    autocompleteInput.addEventListener('focus', this.onFocus, true)
  },

  methods: {
    clickedTerm(term) {
      this.forcefocus();
      this.OnInputChange(term);
      this.storesearch(term);
    },

    cancelAllOpenRequests() {
      for (const controller of this.cancelTokenContollerList) {
        controller.abort();
      }
      this.cancelTokenContollerList = [];
    },

    forceblur() {
      this.searchfieldOpen = false
      this.$refs.Searchfield ? this.$refs.Searchfield.blur() : null;
    },

    forcefocus() {
      this.searchfieldOpen = true;
      this.$refs.Searchfield.focus();
    },

    onFocus() {
      this.openMenu();
    },

    openMenu() {
      this.$refs.Searchfield.isMenuActive = true  // open item list
    },

    closeMenu() {
      this.$refs.Searchfield.isMenuActive = false  // close item list
    },

    OnInputChange(val) {
      this.SearchQuery = val;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      //if (val.length < 2) return; // ignore if less (no emits)
      this.searchTimeout = setTimeout(() => {
        this.search(val);
        this.searchTimeout = null;
      }, this.timeout);
    },

    OnPressEnter() {
      this.storesearch(this.SearchQuery);
    },

    storesearch(query) {
      if (query) {
        var temp = Object.assign([], this.PastSearches);
        temp = temp.filter((x) => x.query.toLowerCase() != query);
        temp.unshift({ query, stamp: new Date() });
        this.PastSearches = temp;
      }
    },

    clearSearchHistory() {
      this.PastSearches = [];
    },

    search(query) {
      this.cancelAllOpenRequests();
      if (query) {
        const controller = new AbortController();
        const cancelationToken = controller.signal;
        this.cancelTokenContollerList.push(controller);
        this.searchCustomers(query, cancelationToken);
        this.searchJobs(query, cancelationToken);
        this.searchMachines(query, cancelationToken);
        //this.searchArticles(query);
      }
      else {
        this.resultset = {}
      }
    },

    async wrapperSearch({ query, defaultwrap, key, method }) {
      var wrap = (this.resultset[key] ?? defaultwrap);
      wrap.loading = query;
      wrap.error = null;
      Vue.set(this.resultset, key, wrap);

      await method()
        .then((res) => {
          wrap.error = null;
          if (res.Content) {
            res = res.Content;
          }
          wrap.list = res;
        })
        .catch((e) => {
          console.error('error', e);
          wrap.list = [];
          wrap.error = e;
        }).finally(() => {
          if (wrap.loading == query) {
            wrap.loading = false;
          }
        });
    },

    searchCustomers(query, cancelationToken) {
      var wrap = {
        icon: "$customer",
        tag: "Customers",
        display: this.$t('servicesystem.common_objects.customer.customers'),
        itemtextkey: "Name",
        list: [],
        onViewAll: q => { this.$router.push({ name: 'CustomerList', query: { 'CL-filter-keyword': `"${q}"` } }); } //CL- is the pk prefix for the customer list
      };
      this.wrapperSearch({
        query: query,
        defaultwrap: wrap,
        key: 'Customers',
        method: () => { return this.getCustomerListFromFilter({ SearchWord: query, ItemsPerPage: 15 }, cancelationToken) }
      });
    },


    searchJobs(query, cancelationToken) {
      var wrap = {
        icon: "$job",
        tag: "Jobs",
        display: this.$t('servicesystem.common_objects.job.jobs'),
        itemtextkey: "DisplayName",
        list: [],
        onViewAll: q => { this.$router.push({ name: 'JobList', params: { filter: 'browse' }, query: { 'AJL-filter-keyword': `"${q}"` } }); }
      };
      this.wrapperSearch({
        query: query,
        defaultwrap: wrap,
        key: 'Jobs',
        method: () => { return this.getJobListFromFilter({ SearchWord: query, ItemsPerPage: 15 }, cancelationToken) }
      });
    },

    searchMachines(query, cancelationToken) {
      var wrap = {
        icon: "$machine",
        tag: "Machines",
        display: this.$t('servicesystem.common_objects.machine.machines'),
        type: "Machine",
        itemtextkey: "DisplayName",
        list: [],
        onViewAll: q => { this.$router.push({ name: 'MachineList', query: { 'ML-filter-keyword': `"${q}"` } }); } //ML- is the pk prefix for the machine list
      };
      this.wrapperSearch({
        query: query,
        defaultwrap: wrap,
        key: 'Machines',
        method: () => { return this.searchMachineByString({ searchQuery: query, CustomerId: undefined, IncludeInactive: true }, cancelationToken); }
      });
    },

    toggleHide(item) {
      Vue.set(item, "hide", !item.hide);
    },
  },

  computed: {
    activeWrapperCount() {
      return Object.keys(this.resultset).filter((x) => !this.resultset[x].hide).length;
    },

    totalresultcount() {
      var count = 0;
      var topparent = this.resultset;
      for (const wrapperkey in topparent) {
        if (Object.hasOwnProperty.call(topparent, wrapperkey)) {
          const wrapper = topparent[wrapperkey];
          count = count + wrapper.list.length;
        }
      }
      return count;
    },

    PastSearches: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("GlobalSearchHistory");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "GlobalSearchHistory", value: update });
      },
    },

    SearchQuery: {
      get() {
        return this.$store.state.globalSearchQuery;
      },
      set(update) {
        if (!update) {
          update = "";
        }
        this.$store.state.globalSearchQuery = update;
      },
    },
  },

  watch: {
    searchfieldOpen: function (newVal) {
      this.$emit("WidthChange", newVal);
    },

    blurtrigger: function () {
      this.forceblur();
      this.closeMenu();
    },
    focustrigger: function () {
      this.forcefocus();
    },

    "$route.name": function () {
      this.forceblur();
    },
    "$route.params": function () {
      this.forceblur();
    },
  },
};
</script>


<style lang="scss">
.collapsingSearchfield {
  z-index: 2000;
  width: 45vw !important;
  //transition: max-width 0.1s;
}

.mobile.collapsingSearchfield {
  width: calc(100vw - 140px) !important;
}

.collapsingSearchfield input {
  font-size: 25px !important;
  padding-bottom: 15px !important;
}

/* only safari */
@supports (-webkit-appearance:none) and (stroke-color:transparent) {
  .collapsingSearchfield input {
    font-size: 18px !important;
  }
}

.collapsingSearchfield.closed fieldset {
  border: none !important;
}

.collapsingSearchfield.closed .v-input__control .v-input__slot::before {
  border: none !important;
}

.collapsingSearchfield.closed {
  max-width: 24px !important;
  //transition: max-width 0.1s;
}

.collapsingSearchfield .v-input__prepend-inner {
  margin-top: 2px !important;
}

.collapsingSearchfield.closed .v-input__prepend-inner {
  margin-top: 5px !important;
}
</style>